import {createSlice} from "@reduxjs/toolkit";
import {STATE_NAMES} from "./StateNames";

const ProjectTypeSlice = createSlice({
    name: STATE_NAMES.PROJECT_TYPES,
    initialState: [],
    reducers: {
        setProjectTypes: (state, action) => {
            return action.payload;
        },
    },
});

export const { setProjectTypes } = ProjectTypeSlice.actions;

export default ProjectTypeSlice.reducer;